import React from "react";
import { connect } from "react-redux";

import AstrologyDetail from "./AstrologyDetail";
import getMyUserAstrologyProfile from "../../../../../_selectors/userSelectors/getMyUserAstrologyProfile";
const Astrology = ({ userProfile, update, showToast }) => {
  return (
    <AstrologyDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserAstrologyProfile(state)
});

export default connect(mapStateToProps)(Astrology);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Astrology/index.js